export default __webpack_public_path__ + "static/media/contact success.dd240887.jpg";